import { useCallback } from "react";

import Box from "ds/components/Box";
import IconEmphasized from "ds/components/IconEmphasized";
import TileWrapper from "ds/components/Tile/Wrapper";
import { IconComponent } from "types/Icon";
import TileTitle from "ds/components/Tile/Title";
import TileDescription from "ds/components/Tile/Description";
import Toggle from "ds/components/Toggle";

import styles from "./styles.module.css";

type FeatureToggleTileProps = {
  title: string;
  description: string;
  icon: IconComponent;
  iconBackground: "purple" | "orange";
  onChange?: (value: boolean) => void;
  checked: boolean;
};

const FeatureToggleTile = ({
  onChange,
  icon,
  title,
  description,
  checked,
  iconBackground,
}: FeatureToggleTileProps) => {
  const handleChange = useCallback(() => {
    onChange?.(!checked);
  }, [checked, onChange]);

  return (
    <TileWrapper onClick={onChange ? handleChange : undefined}>
      <Box align="start" justify="between" fullWidth>
        <Box align="start" grow="1" gap="medium">
          <IconEmphasized icon={icon} color={iconBackground} className={styles.icon} />
          <Box direction="column" gap="small">
            <TileTitle>{title}</TileTitle>
            <TileDescription>{description}</TileDescription>
          </Box>
        </Box>
        {!!onChange && <Toggle variant="switch" isSelected={checked} className={styles.toggle} />}
      </Box>
    </TileWrapper>
  );
};

export default FeatureToggleTile;
